module.exports = __webpack_public_path__ + "img/293.4efb1882.jpg";